import React from 'react';
import { classnames } from 'helpers/utils';
import qrImage from 'assets/images/qrcode.png';
import { StoreStateType } from 'context/store-context/store-reducer';
import { useMediaQuery } from 'hooks/use-media-query';
import { Breakpoints } from 'common/enums';
import styles from './checkout.module.scss';

type ConfirmOrderProps = {
  state: StoreStateType;
};

export const ConfirmOrder: React.FC<ConfirmOrderProps> = ({ state }) => {
  const isMobile = useMediaQuery(`(max-width: ${Breakpoints.sm}px)`);
  return (
    <>
      <div
        className={classnames(
          'text__body__regular__overline__gray800',
          styles.itemsTitle,
        )}
      >
        CONFIRM YOUR ORDER
      </div>
      {state.itemsInCart?.map((item) => (
        <div className={styles.cartItem}>
          <img
            src={item.image || qrImage}
            alt="Avatar"
            className={styles.cartItemImage}
          />
          <div>
            <div
              className={
                isMobile
                  ? 'text__body__semi__bold__large__gray800'
                  : 'text__title1__gray800'
              }
            >
              <span
                className={
                  isMobile
                    ? 'text__body__semi__bold__large__brand500'
                    : 'text__title1__brand500'
                }
              >
                {item.mountOfItems}x
              </span>{' '}
              {item.name}
            </div>
            <div
              className={
                isMobile
                  ? 'text__body__semi__bold__large__gray700'
                  : 'text__title2__gray700'
              }
            >
              ${item.priceOneItem.toFixed(2)}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
